const ACCORDION = {
    accordions: document.querySelectorAll('.akkordeon__detail'),
    onReady() {
        ACCORDION.accordions.forEach(accordion => {
            accordion.addEventListener('click', event => {
                (event.target.tagName !== 'A') && event.preventDefault();
                ACCORDION.onClick({ element: accordion });
            });
        });
    },
    onClick({element}) {
        ACCORDION.accordions.forEach(accordion => {
            accordion.style.overflow = 'hidden';
            (element !== accordion) && (ACCORDION.shrink({element: accordion}));
        });
        (element.open) ? ACCORDION.shrink({element: element}) : ACCORDION.open({element: element});
    },
    open({element}) {
        element.style.height = `${element.offsetHeight}px`;
        element.open = true;
        window.requestAnimationFrame(() => ACCORDION.expand({element: element}));
    },
    expand({element}) {
        const content     = element.querySelector('.akkordeon__content');
        const startHeight = `${element.offsetHeight}px`;
        const endHeight   = `${element.offsetHeight + content.offsetHeight}px`;
        (element.animation) && element.animation.cancel();
        element.animation = element.animate({
            height: [startHeight, endHeight]
        }, {
            duration: 150,
            easing: 'ease-out'
        });
        element.animation.onfinish = () => {
            ACCORDION.onAnimationFinish({element: element, open: true});
            // setTimeout(() => {
            //     let offset  = document.getElementById('header').clientHeight;
            //     let scrollY = element.getBoundingClientRect().top + window.pageYOffset - offset;
            //     window.scrollTo(0, scrollY);
            // }, 200);
        }
    },
    shrink({element}) {
        if (element.open === false) return;
        const content     = element.querySelector('.akkordeon__content');
        const startHeight = `${element.offsetHeight}px`;
        const endHeight   = `${element.offsetHeight - content.offsetHeight - 24}px`;
        
        (element.animation) && element.animation.cancel();
        
        element.animation = element.animate({
            height: [startHeight, endHeight]
        }, {
            duration: 150,
            easing: 'ease-out'
        });
        element.animation.onfinish = () => ACCORDION.onAnimationFinish({element: element, open: false});
    },
    onAnimationFinish({element, open}) {
        (open) ? element.classList.add('active') : element.classList.remove('active'); // for tracking purposes
        element.open = open;
        element.style.height = '';
        element.style.overflow = '';
    }
}